interface LoaderProps {
    className?: string
    withBackdrop?: boolean
}

const Loader = ({ className, withBackdrop: withBackdrop }: LoaderProps) => {
    return withBackdrop ? (
        <div className={'bg-white fixed inset-0 opacity-90'} style={{ zIndex: 1000 }}>
            <span className={`inline-loader absolute ${className} top-1/2 left-1/2`} style={{ transform: 'translate(-50%, -50%)' }}></span>
        </div>
    ) : (
        <div>
            <span className={`inline-loader ${className}`}></span>
        </div>
    )
}

export default Loader
